<template>
  <div class="box-shadow">
    <!-- <div class="" style="display:flow-root;" v-if="can_access('stock','upload')">
    <a href="javascript:;" class="pull-right" @click="showModal('upload-deal-ticket-out')" v-if="can_access('stock','upload')">Upload Deal Ticket CSV</a>
  </div> --> 
  <form>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-4 form-group">
          <label>Security Type</label>
          <select name="type" class="form-control" v-model="formInput.type">
            <option value="equity" selected>Equity</option>
            <option value="non-equity">Non Equity</option>
            <option value="options">Options</option>
            <option value="futures">Futures</option>
            <option value="bonds">Bonds</option>
            <option value="fx">FX</option>
            <option value="fx_options">FX Options</option>
            <option value="structured_notes">Structured Notes</option>
          </select>
        </div>    
      </div>
      <div class="row">  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.tidm')}">
          <label>Ticker(TIDM)</label><span class="message">{{ validation.firstError('formInput.tidm') }}</span>
          <vue-bootstrap-typeahead
                ref="tidm"
                :data="instruments"
                v-model="formInput.tidm"
                :serializer="InstrumentFormattedDisplay"
                placeholder="Search Ticker"
                @hit="setInstrumentInfo"
              />
          <!--<input type="text" placeholder="Enter TIDM Here.." class="form-control" v-model="formInput.tidm">-->
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.exchange_name')}">
          <label>Exchange Name</label><span class="message">{{ validation.firstError('formInput.exchange_name') }}</span>
          <!-- <input type="text" placeholder="Enter Exchange Name Here.." class="form-control" v-model="formInput.exchange_name"> -->
          <vue-bootstrap-typeahead
                ref="exchange_name"
                :data="exchanges"
                v-model="formInput.exchange_name"
                :serializer="ExchangeFormattedDisplay"
                placeholder="Search Exchange Name"
                @hit="setExchangeInfo"
              />
        </div>  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.issuer_name')}">
          <label>Instrument/Security Name</label><span class="message">{{ validation.firstError('formInput.issuer_name') }}</span>
          <input type="text" placeholder="Enter Instrument Name Here.." class="form-control" v-model="formInput.issuer_name">
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.isin')}">
          <label>ISIN</label><span class="message">{{ validation.firstError('formInput.isin') }}</span>
          <input type="text" placeholder="Enter ISIN Here.." class="form-control" v-model="formInput.isin">
        </div> 
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.sedol')}">
          <label>SEDOL</label><span class="message">{{ validation.firstError('formInput.sedol') }}</span>
          <input type="email" placeholder="Enter SEDOL Here.." class="form-control" v-model="formInput.sedol">
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.cusip')}">
          <label>CUSIP</label><span class="message">{{ validation.firstError('formInput.cusip') }}</span>
          <input type="text" placeholder="Enter CUSIP Here.." class="form-control" v-model="formInput.cusip">
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stamp_duty_exemption_start_date')}">
          <label>Stamp Duty Exemption Start Date (DD-MM-YYYY)</label><span class="message">{{ validation.firstError('formInput.stamp_duty_exemption_start_date') }}</span><br>
          <date-picker input-class="form-control" ref="stamp_duty_exemption_start_date" type="date" v-model="formInput.stamp_duty_exemption_start_date" value-type="format" format='DD-MM-YYYY'></date-picker>
        </div>   
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stamp_duty_exemption_end_date')}">
          <label>Stamp Duty Exemption End Date (DD-MM-YYYY)</label><span class="message">{{ validation.firstError('formInput.stamp_duty_exemption_end_date') }}</span><br>
          <date-picker input-class="form-control" ref="stamp_duty_exemption_end_date" type="date" v-model="formInput.stamp_duty_exemption_end_date" value-type="format" format='DD-MM-YYYY'></date-picker>
        </div>   
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.currency')}">
          <label>Currency</label><span class="message">{{ validation.firstError('formInput.currency') }}</span>
          <input type="text" placeholder="Enter Currency Here.." class="form-control" v-model="formInput.currency">
        </div>  
      </div>
      <div class="row" v-if="['bonds', 'structured_notes'].indexOf(formInput.type)>=0">
        <div class="col-sm-4 form-group">
          <label>Coupon Rate(%)</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.coupon_rate">
        </div>
        <div class="col-sm-4 form-group">
          <label>Last Coupon Date</label>
          <date-picker input-class="form-control" ref="last_coupon_date" v-model="formInput.other_details.last_coupon_date" value-type="format" format='DD-MM-YYYY'></date-picker>
        </div>
        <div class="col-sm-4 form-group">
          <label>Maturity</label>
          <date-picker input-class="form-control" ref="maturity" v-model="formInput.other_details.maturity" value-type="format" format='DD-MM-YYYY'></date-picker>
        </div>
        <div class="col-sm-4 form-group form-check">
          <input type="checkbox" class="form-check-input" id="is_defaulted_checkbox" v-model="formInput.other_details.is_defaulted">
          <label class="form-check-label" for="is_defaulted_checkbox">Mark as Defaulted</label>
        </div>
      </div>
      <div class="row" v-if="['futures', 'options', 'fx_options'].indexOf(formInput.type)>=0">
        <div class="col-sm-4 form-group">
          <label>Underlying</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.underlying">
        </div>
        <div class="col-sm-4 form-group">
          <label>Strike</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.strike">
        </div>
        <div class="col-sm-4 form-group">
          <label>Expiry</label>
          <date-picker input-class="form-control" ref="expiry" v-model="formInput.other_details.expiry" value-type="format" format='DD-MM-YYYY'></date-picker>
        </div>
      </div>

      <div class="form-group">
        <a href="#" @click="setShowDetailedForm">add {{lessOrMore}} details</a>
      </div>
      <div class="row" v-if="showDetailedForm">
        <div class="col-sm-4 form-group">
          <label>CFD Provider Name</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.extra_details.iress_cfd_provide_name" readonly>
        </div>
        <div class="col-sm-4 form-group">
          <label>Security Code</label>
          <input type="text" placeholder="Enter IRESS Security Code Here.." class="form-control" v-model="formInput.extra_details.iress_security_code" readonly>
        </div>
        <div class="col-sm-4 form-group">
          <label>IRESS Exchange Name</label>
          <input type="text" placeholder="Enter IRESS Exchange Name Here.." class="form-control" v-model="formInput.extra_details.iress_exchange_name" readonly>
        </div>
        <div class="col-sm-4 form-group">
          <label>IRESS Ticker(TIDM)</label>
          <input type="text" placeholder="Enter IRESS Ticker.." class="form-control" v-model="formInput.other_details.iress_ticker">
        </div>
        <div class="col-sm-4 form-group">
          <label>IRESS Margin Percent</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.iress_margin_percent">
        </div>
        <div class="col-sm-4 form-group">
          <label>IRESS Contract Fee</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.iress_contract_fee">
        </div>
        <div class="col-sm-4 form-group">
          <label>Short Sellable</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.iress_short_sellable">
        </div>
        <div class="col-sm-4 form-group">
          <label>Allow Buys</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.iress_allow_buys">
        </div>
        <div class="col-sm-4 form-group">
          <label>Short Sell Volume Maximum</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.iress_short_sell_volume_maximum">
        </div>
        <div class="col-sm-4 form-group">
          <label>Lot Size</label>
          <input type="text" placeholder="Enter IRESS Exchange Name Here.." class="form-control" v-model="formInput.other_details.iress_lot_size">
        </div>
        <div class="col-sm-4 form-group">
          <label>Collateral Ratio</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.iress_collateral_ratio">
        </div>
        <div class="col-sm-4 form-group">
          <label>Long Volume Maximum</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.iress_long_volume_maximum">
        </div>
        <div class="col-sm-4 form-group">
          <label>Allow Trading</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.iress_allow_trading">
        </div>
        <div class="col-sm-4 form-group">
          <label>Position Short Sell Volume Maximum</label>
          <input type="text" placeholder="Enter Here.." class="form-control" v-model="formInput.other_details.iress_position_short_sell_volume_maximum">
        </div>
        <div class="col-sm-4 form-group">
          <label>Position Long Volume Maximum</label>
          <input type="text" placeholder="Enter IRESS Exchange Name Here.." class="form-control" v-model="formInput.other_details.iress_position_long_volume_maximum">
        </div>
      </div>
      
      <input type="hidden" v-model="formInput.id"/>
      <div class="" style="display:flow-root">
        <button type="button" v-on:click="addSecurities" class="pull-right btn btn-lg btn-info">Submit</button>     
      </div>  
         
    </div>
  </form>
  <b-modal ref="upload-deal-ticket-out" title="Upload Deal Ticket" size="xl" hide-footer v-if="can_access('stock','upload')">
    <p class="my-4"><UploadDealTicketForm :forceRerender="uploadDealTicketFormReRender" uri="import_stocks"/></p>
  </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import common from '@/assets/js/common.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import SimpleVueValidator from 'simple-vue-validator';
import UploadDealTicketForm from '@/components/Accounts/UploadTradesCSV';

const Validator = SimpleVueValidator.Validator;
export default {
  name: 'AddSecurityForm',
  props:['forceRerender','rows'],
  components: { DatePicker,VueBootstrapTypeahead,UploadDealTicketForm },
  mixins: [common,SimpleVueValidator.mixin],
  data(){
    return {
      showDetailedForm: false,
      lessOrMore: "more",
      securities: [],
      instruments: [],
      group: {},
      exchanges: [],
      formInput:{
        'id' : '',
        'type' : 'equity',
        'tidm' : '',
        'exchange_name' : '',
        'exchange_id': 0,
        'country_id': '',
        'issuer_name' : '',
        'isin': '',
        'sedol' : '',
        'cusip' : '',
        'stamp_duty_exemption_start_date' : '',
        'stamp_duty_exemption_end_date' : '',
        'currency' : '',
        'status': 1,
        'other_details': {
          'coupon_rate': '',
          'last_coupon_date': '',
          'maturity': '',
          'underlying': '',
          'strike': '',
          'expiry': '',
          'is_defaulted': '',
          'iress_ticker': '',
          'iress_margin_percent': '',
          'iress_contract_fee': '',
          'iress_short_sellable': '',
          'iress_allow_buys': '',
          'iress_short_sell_volume_maximum': '',
          'iress_lot_size': '',
          'iress_collateral_ratio': '',
          'iress_long_volume_maximum': '',
          'iress_allow_trading': '',
          'iress_position_short_sell_volume_maximum': '',
          'iress_position_long_volume_maximum': ''
        },
        'extra_details': {
          'iress_cfd_provide_name': this.config('app.name'),
          'iress_exchange_name': '',
          'iress_security_code': '',
        }
      }
    };
  },
  validators: {
    'formInput.tidm': function(value) {
      return Validator.value(value).required();
    },
    'formInput.exchange_name': function(value) {
      return Validator.value(value);
    },
    'formInput.issuer_name': function(value) {
      return Validator.value(value);
    },
    'formInput.isin': function(value) {
      return Validator.value(value).required();
    },
    'formInput.sedol': function(value) {
      return Validator.value(value)/* .required() */;
    },
    'formInput.cusip': function(value) {
      return Validator.value(value);
    },
    'formInput.stamp_duty_exemption_start_date': function(value) {
      return Validator.value(value).regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3}))$', 'Not in Valid Format: DD-MM-YYYY.');
    },
    'formInput.stamp_duty_exemption_end_date': function(value) {
      return Validator.value(value).regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3}))$', 'Not in Valid Format: DD-MM-YYYY.');
    },
    'formInput.currency': function(value) {
      return Validator.value(value).required();
    },
  },
  watch: {
    'formInput.tidm': function (input) {
      this.$refs.tidm.inputValue = input;
      this.group={};
      //this.formInput.id = '';
      this.getInstrumentByTicker(input);
      this.formInput.extra_details.iress_security_code = input.split('.')[0]
    },
    'formInput.exchange_name': function(input){
      this.getExchangeInfo(input)
      this.formInput.extra_details.iress_exchange_name = this.formInput.exchange_name
    },
    'formInput.id': function(){
      if(this.formInput.status == 0) this.addSecurities();
    },
  },
  methods: {
    addSecurities: function(){
      this.$validate()
          .then(async (success) => {
            if (success) {
              const {response} = await this.call_axios('add_stocks', 'post', this.formInput);
              this.forceRerender(response);
            }
          });
    },
    async getInstrumentByTicker (input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['tidm'] = encodeURIComponent(input);
      var uri = 'stock_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.instruments = response.data.result;
    },
    setInstrumentInfo (group) {
      if(typeof group == "object"){console.log(group);
        this.group = group;
        Object.assign(this.formInput, group);
        this.setExchangeInfo(group)
      }
    },
    InstrumentFormattedDisplay (result) {
      return result.tidm;
    },
    setShowDetailedForm: function(e){
      e.preventDefault();
      this.showDetailedForm = this.showDetailedForm?false:true;
      this.lessOrMore = this.showDetailedForm?"less":"more";
    },
    showModal(model) {
      this.$refs[model].show()
    },
    uploadDealTicketFormReRender(reaponse){
      if(response.code==0){
          this.$refs['upload-deal-ticket-out'].hide()
          this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    async getExchangeInfo (input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['exchange_name'] = encodeURIComponent(input);
      var uri = 'exchange_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.exchanges = response.data?response.data.result:[];
    },
    ExchangeFormattedDisplay (result) {
      return result.exchange_name+' ('+result.country_code+')';
    },
    setExchangeInfo (group) {
      Object.assign(this.formInput, group);
      this.formInput.exchange_name = (typeof group == "object") ? group.exchange_name : group;
      this.$refs.exchange_name.inputValue = (typeof group == "object") ? group.exchange_name : group;
    },
  },
  mounted(){
  },
  created(){
    if(typeof this.rows != 'undefined'){
      Object.assign(this.formInput, this.rows);
    }
  }
};
</script>

<style lang="scss" scoped>
.mx-datepicker{
  width: 100%;
}
.heading{
  font-weight:600;
}
.error .message{
  padding: 0px 5px;
  color: red;
} 
.form-check{
  padding-left: 30px !important;
}
</style>